<template>
  <div>
    <el-card>
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="font-weight:600;">
          首页轮播图设置
        </div>
        <div style="display:flex;gap:10px;">
          <el-button type="primary" @click="openAdd">新增轮播图</el-button>
        </div>
      </div>
      <el-table :data="banners" style="width: 100%; margin-top: 16px;">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column label="轮播图" width="200" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pict" :src="formatPict(scope.row.pict)" style="width:120px;height:80px;" 
              fit="cover" />
            <div v-else 
              style="width:120px;height:80px;background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">
              无图</div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="220" show-overflow-tooltip />
        <el-table-column prop="sort" label="排序" width="80" align="center" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="removeBanner(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="isEdit ? '编辑轮播图' : '新增轮播图'" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">

        <el-form-item label="轮播图片">
          <div class="uploader-container">
            <div v-if="form.image_url" class="uploader-list">
              <div class="uploader-item">
                <el-image :src="form.image_url" style="width:100%;height:150px;" fit="cover" />
                <span class="uploader-remove" @click="removePicture">
                  <i class="el-icon-delete"></i>
                </span>
              </div>
            </div>
            <el-upload 
              class="uploader" 
              :auto-upload="false" 
              :show-file-list="false" 
              :http-request="handleUpload"
              :on-change="onFileChange" 
              accept="image/*"
              v-if="!form.image_url"
            >
              <i class="el-icon-plus uploader-icon"></i>
              <div class="uploader-text">点击上传</div>
            </el-upload>
          </div>
          <div style="color: #909399; font-size: 12px; margin-top: 10px;">
            建议尺寸：1200x400px
          </div>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="form.sort" :min="0" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { BannerList, BannerEdit, BannerRemove } from '@/api/api.js'

export default {
  name: 'AdminBanner',
  data() {
    return {
      banners: [],
      dialogVisible: false,
      isEdit: false,
      editingId: null,
      form: {
        id: null,
        title: '',
        image_url: '',
        sort: 0,
        status: 1
      },
      rules: {
        title: [{ required: true, message: '请输入轮播图标题', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchBannerList()
  },
  methods: {
    fetchBannerList() {
      BannerList().then(res => {
        this.banners = res.data || []
      }).catch(err => {
        console.error('获取轮播图列表失败:', err)
        this.banners = []
      })
    },
    openAdd() {
      this.isEdit = false
      this.editingId = null
      this.resetForm()
      this.dialogVisible = true
    },
    openEdit(row) {
      this.isEdit = true
      this.editingId = row.id
      this.resetForm()
      Object.assign(this.form, row)
      if (!this.form.image_url && row.pict) {
        this.form.image_url = this.formatPict(row.pict)
      }
      this.dialogVisible = true
    },
    resetForm() {
      this.form = {
        id: null,
        title: '',
        image_url: '',
        sort: 0,
        status: 1
      }
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return

        const imageUrl = this.form.image_url || ''
        let pict = ''
        if (imageUrl) {
          const commaIndex = imageUrl.indexOf(',')
          pict = commaIndex !== -1 ? imageUrl.slice(commaIndex + 1) : imageUrl
        }

        const payload = {
          id: this.isEdit ? (this.form.id || this.editingId || 0) : 0,
          sort: this.form.sort || 0,
          status: this.form.status,
          pict
        }

        BannerEdit(payload).then(res => {
          if (res.code === 200 || res.status === 200 || res.success) {
            this.$message.success(this.isEdit ? '更新成功' : '新增成功')
            this.fetchBannerList()
            this.dialogVisible = false
          } else {
            this.$message.error(res.msg || (this.isEdit ? '更新失败' : '新增失败'))
          }
        }).catch(err => {
          console.error('保存轮播图失败:', err)
          this.$message.error('请求失败')
        })
      })
    },
    removeBanner(id) {
      this.$confirm('确认删除该轮播图吗？', '提示', { type: 'warning' })
        .then(() => {
          BannerRemove({ id }).then(res => {
            if (res.code === 200 || res.status === 200 || res.success) {
              this.$message.success('删除成功')
              this.fetchBannerList()
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          }).catch(err => {
            console.error('删除轮播图失败:', err)
            this.$message.error('请求失败')
          })
        })
        .catch(() => { })
    },
    handleUpload(req) {
      const file = req.file
      const reader = new FileReader()
      reader.onload = e => {
        this.form.image_url = e.target.result
      }
      reader.readAsDataURL(file)
    },
    onFileChange(file) {
      if (file.raw) {
        this.handleUpload({ file: file.raw })
      }
    },
    removePicture() {
      this.form.image_url = ''
    },
    formatPict(pict) {
      if (!pict || typeof pict !== 'string') return ''
      const value = pict.trim()
      if (!value) return ''
      if (value.indexOf('data:') === 0) return value
      return 'data:image/jpeg;base64,' + value
    }
  }
}
</script>

<style>
.uploader-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  height: 150px;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
}

.uploader-list {
  width: 100%;
}

.uploader-item {
  position: relative;
  width: 100%;
  height: 150px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}

.uploader-remove {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  font-size: 16px;
}

.uploader-remove:hover {
  background: rgba(0, 0, 0, 0.7);
}

.uploader-icon {
  font-size: 32px;
  color: #8c939d;
  margin-bottom: 10px;
}

.uploader-text {
  color: #8c939d;
  font-size: 14px;
}
</style>
